"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketPolicyInput_1 = require("./GetBucketPolicyInput");
var GetBucketPolicyOutput_1 = require("./GetBucketPolicyOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketPolicy = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketPolicy",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?policy"
    },
    input: {
        shape: GetBucketPolicyInput_1.GetBucketPolicyInput
    },
    output: {
        shape: GetBucketPolicyOutput_1.GetBucketPolicyOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketPolicy.js.map